/* Existing GA4 only. Delegation also covers Theme Editor section reloads. */
(() => {
  if (window.pidanCatteryTrackingBound) return;
  window.pidanCatteryTrackingBound = true;
  document.addEventListener('click', (event) => {
    const cta = event.target instanceof Element && event.target.closest('a.js-cattery-line-cta[href]');
    if (!cta) return;
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'cattery_line_click', { cta_location: cta.dataset.ctaLocation, transport_type: 'beacon' });
      }
    } catch (_) { /* Analytics must never interrupt navigation. */ }
  });
})();
